import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

export type RemoteSignoffShellPart = "nav" | "review" | "send" | "overlay";

@Component({
	selector: "app-remote-signoff-shell",
	templateUrl: "./remote-signoff-shell.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class RemoteSignoffShellComponent {
	@Input() part: RemoteSignoffShellPart = "review";
	@Input() selectedIndex = 0;
	@Input() canSend = false;
	@Input() sending = false;

	@Output() selectStep = new EventEmitter<number>();
	@Output() back = new EventEmitter<void>();
	@Output() nextStep = new EventEmitter<void>();
	@Output() preview = new EventEmitter<void>();
	@Output() send = new EventEmitter<void>();
}
